<div class="container-fluid">
  <div class="row">
    <div class="col-md-8">
      <div class="card shadow-sm">
        <div class="card-header">
          <h3 class="card-title">View Client</h3>
        </div>
        <div class="card-body">
          <customers-form [readonlyCustomerForm]="readonly" [customer]="customer" />
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <ranking-bar [readonlyRankingBar]="readonly" [ranking]="customer?.ranking" />
      <customers-client-code [readonlyClientCode]="readonly" [customer]="customer"/>
      <customers-nda [customer]="customer" />
    </div>
  </div>
  <div class="row">
    <div [ngClass]="isRestrictedCustomerProfile ? 'col-12' : 'col-6'">
      <documents-panel [readonlyDocumentsPanel]="false" [customer]="customer" [hideAddDocument]="isRestrictedCustomerProfile" />
    </div>
    @if (!isRestrictedCustomerProfile) {
      <div class="col-6">
        <customers-welcome-letter [readonlyWelcomeLetter]="false" [customer]="customer" [clientPersons]="clientPersons" [personSentWelcomeLetter]="personSentWelcomeLetter" (onSavedData)="onWelcomeLetterSaved($event)" />
      </div>
    }
  </div>
  @if (customer != null && clientPersons?.length) {
    <div class="row">
    </div>
  }
  @if (customer != null) {
    <div class="row">
      <contacts-customers-form [readonlyContactsCustomer]="readonly" [clientPersons]="clientPersons" [inCustomerDetailPage]="true" [hideActionsColumn]="hideContactsActions" />
    </div>
  }
  @if (!isRestrictedCustomerProfile) {
    <div class="row mt-4">
      <notes-customers-form [readonlyCustomerNotes]="readonly" [customer]="customerNotes" />
    </div>
  }

</div>